<template>
  <EditorSideList
    :items="ws.planNames.value"
    :selected-index="selectedIndex"
    add-label="Add Battleplan"
    empty-hint="No battleplans yet."
    width-key="studio:sidebarWidth"
    show-index
    @select="onSelect"
    @add="openAdd"
    @reorder="ws.movePlan"
  >
    <template #row="{ item }">{{ item }}</template>
  </EditorSideList>

  <!-- Battleplans are keyed by name, so adding prompts for one. -->
  <NameModal
    :open="adding"
    title="New Battleplan"
    placeholder="Battleplan name…"
    @confirm="handleAdd"
    @close="adding = false"
  />
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useWorkspace } from '../state/workspace.js';
import EditorSideList from './EditorSideList.vue';
import NameModal from './NameModal.vue';

const ws = useWorkspace();
const adding = ref(false);

const selectedIndex = computed(() => ws.planNames.value.indexOf(ws.currentPlan.value ?? ''));

function onSelect(index: number) {
  const name = ws.planNames.value[index];
  if (name) ws.selectPlan(name);
}

function openAdd() {
  adding.value = true;
}

function handleAdd(name: string) {
  ws.addPlan(name);
  adding.value = false;
}
</script>
